import React, { useState } from "react";
import "./PGalleryGrid.css";
import imageData from "./imageData";

const locationOptions = [
    "Living Room",
    "Kitchen",
    "Bedroom",
    "Bathroom",
    "Office",
    "Lounge Area",
    "Dinning Room",
    "Children room",
];

const productOptions = [
    "Roller Blinds",
    "Roman Blinds",
    "Colby Blinds",
    "Grayson Blinds",
    "Sierra Blinds",
    "Eton Blinds",
    "Wooden Venetian Blinds",
    "Dorren Blinds",
    "Meliso Blinds",
    "Luzon Blinds",
    "Aric Blinds",
    "Patricia Blinds",
    "Panel Blinds",
    "Vertical Blinds",
    "Skylight Colby Blinds",
    "Skylight Roman Blinds",
    "Curtain with Blinds",
];

const NUM_COLUMNS = 4;

const PGalleryGrid = () => {
    const [filter1, setFilter1] = useState("");
    const [filter2, setFilter2] = useState("");

    const handleClearFilters = () => {
        setFilter1("");
        setFilter2("");
    };

    const filterImages = () => {
        return imageData.filter((img) => {
            if (!img.keywords && (filter1 || filter2)) return false; // Skip if no keywords and filters are active

            // If no filters are selected, show all images (except completely empty ones)
            if (!filter1 && !filter2) return !!img.src; // Show if image has src

            // Split keywords into an array, trim whitespace, and convert to lowercase
            const keywordArray = img.keywords ? img.keywords.split(',').map(k => k.trim().toLowerCase()) : [];

            // Check filter1 against any of the keywords
            const match1 = filter1
                ? keywordArray.some(keyword => keyword.includes(filter1.toLowerCase()))
                : true;

            // Check filter2 against any of the keywords
            const match2 = filter2
                ? keywordArray.some(keyword => keyword.includes(filter2.toLowerCase()))
                : true;

            return match1 && match2 && !!img.src; // Must have src to be shown
        });
    };

    const distributeImagesToColumns = (images, columnsCount) => {
        const columns = Array.from({ length: columnsCount }, () => []);
        images.forEach((img, idx) => {
            columns[idx % columnsCount].push(img);
        });
        return columns;
    };

    const filteredImages = filterImages();
    const columns = distributeImagesToColumns(filteredImages, NUM_COLUMNS);

    return (
        <div className="ImageGallery-pg">
            <div className="gallery-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Product Photos</h1>
                </div>

                <div className="filter-bar">
                    <select
                        value={filter1}
                        onChange={(e) => setFilter1(e.target.value)}
                        className="filter-dropdown  filter-d1"
                    >
                        <option value="">Location...</option>
                        {locationOptions.map((opt, idx) => (
                            <option key={idx} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>

                    <select
                        value={filter2}
                        onChange={(e) => setFilter2(e.target.value)}
                        className="filter-dropdown filter-d2"
                    >
                        <option value="">Product...</option>
                        {productOptions.map((opt, idx) => (
                            <option key={idx} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>

                    <button onClick={handleClearFilters} className="clear-button">
                        Clear All Filters
                    </button>
                </div>

                {filteredImages.length > 0 ? (
                    <div className="gallery-flex">
                        {columns.map((col, colIdx) => (
                            <div className="flex-column" key={colIdx}>
                                {col.map((img, idx) => (
                                    <div className="gallery-item" key={idx}>
                                        <img src={img.src} alt={img.title} />
                                        <div className="overlay">
                                            <div className="overlay-text">{img.title}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-items-message">
                        <p>There are no items in that Selection.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PGalleryGrid;
